import type {
  AccountUiCopy,
  BackendSmokeCopy,
  Copy,
  MicrophonePermissionCopy,
  ProviderInteractivePromptCopy,
  RemoteAudioInstallSmokeCopy,
  RewardedAdUnlockSmokeCopy,
  RewardedUnlockPromptCopy,
  SetupLevelSubtitleCopy,
} from "./appCopy";

// Auto-generated from English shell copy.
// Native editorial review is still required before release changes.

export const AR_COPY: Copy = {
  "appKicker": "صدى ورديناريوس",
  "appTitle": "مدرّب المحادثة",
  "setupStep": "الخطوة",
  "setupLanguagePairTitle": "اختر زوج اللغة",
  "setupAppLanguageLabel": "لغة التطبيق",
  "setupLanguagePairHint": "",
  "setupSpeakLabel": "اللغة التي أتحدثها",
  "setupPracticeLabel": "لغة التعلّم",
  "setupPickerPlaceholder": "اختر اللغة",
  "setupContinue": "تابع",
  "setupLanguagePairConflictHint": "لا توجد لغة تدريب متاحة لهذه اللغة الداعمة حاليًا.",
  "setupLanguageApplyingTitle": "جارٍ إعداد اللغة",
  "setupLanguageApplyingHint": "يتم تجهيز حزم اللغة ومساحات التدريب قبل فتح شاشة المستوى.",
  "setupLanguagePairSummaryTitle": "راجع اختيارك",
  "setupLanguagePairNativeSummary": "اللغة التي أتحدثها",
  "setupLanguagePairTargetSummary": "لغة التعلّم",
  "setupNativeTitle": "بأي لغة تريد الحصول على المساعدة؟",
  "setupNativeHint": "ستظهر الإرشادات والتلميحات بهذه اللغة.",
  "setupTargetTitle": "ما هي اللغة التي تريد أن تتعلمها؟",
  "setupTargetHint": "ستتدرّب على التحدث بهذه اللغة.",
  "setupEnglishAccentTitle": "لكنة الإنجليزية",
  "setupEnglishAccentHint": "اختر اللكنة التي تريد استخدامها في الاستماع واختبار النطق.",
  "setupAccentAmerican": "الأمريكية (الولايات المتحدة)",
  "setupAccentBritish": "البريطانية (المملكة المتحدة)",
  "setupLevelTitle": "ما هو المستوى الذي تريد أن تبدأ به؟",
  "setupLevelHint": "ابدأ من المستوى الأول للحصول على قاعدة قوية.",
  "setupLevelReadyTag": "متاح",
  "setupLevelLockedTag": "قريبا",
  "setupLevelOnlyA1Hint": "المستويات A1 وA2 وB1 وB2 متاحة الآن.",
  "setupNativeLanguageLabel": "اللغة التي أتحدثها",
  "setupNativeLanguageChange": "تغيير",
  "nativeLanguageConfirmTitle": "أكّد اللغة التي تتحدثها",
  "nativeLanguageConfirmQuestion": "هل تريد أن تكون الإرشادات والتلميحات باللغة {languageName}؟",
  "nativeLanguageConfirmHint": "هذا الاختيار يحدد أيضًا اللغة التي تظهر عند الضغط على العلم بجانب محتوى لغة التعلّم.",
  "nativeLanguageConfirmCancel": "تغيير",
  "nativeLanguageConfirmConfirm": "نعم، استخدمها",
  "setupLevelConfirmHint": "بعد المتابعة، ستنتقل مباشرة إلى مجالات التعلّم.",
  "setupLevelConfirmCancel": "إلغاء",
  "setupLevelConfirmLoad": "متابعة",
  "setupLevelConfirmLoading": "جارٍ الفتح...",
  "domainContentPromptTitle": "حزمة المحتوى",
  "domainContentPromptQuestion": "هل تريد تنزيل محتوى السيناريوهات لهذا المجال؟",
  "domainContentPromptHint": "سنجهّز فقط حزمة النصوص الخاصة بهذا المستوى وهذا المجال. ملفات الصوت تُفتح بشكل منفصل عند الحاجة.",
  "domainContentPromptInstall": "تنزيل",
  "domainContentPromptInstalling": "جارٍ تجهيز المحتوى...",
  "domainContentPromptError": "تعذر تجهيز حزمة المحتوى هذه الآن.",
  "cancelLabel": "إلغاء",
  "okLabel": "حسنًا",
  "setupDownloadTitle": "نزّل حزم التعلّم المطلوبة",
  "setupDownloadHint": "سننزّل فقط الملفات الخاصة باللغة والمستوى اللذين اخترتهما.",
  "setupReadyTitle": "كل شيء جاهز",
  "setupReadyHint": "ستشاهد أولًا كيف تُقال العبارات، ثم تتدرّب عليها خطوةً خطوة.",
  "targetLabel": "اللغة المستهدفة",
  "levelLabel": "المستوى",
  "requiredPacks": "الحزم المطلوبة",
  "scenarios": "السيناريوهات",
  "sentences": "الجمل",
  "estimatedSize": "الحجم المقدر",
  "downloadNow": "نزّل الآن",
  "downloading": "جاري التحميل",
  "startLearning": "ابدأ التعلّم",
  "restartSetup": "أعد تشغيل الإعداد",
  "sessionTitle": "درس اليوم",
  "sessionHint": "المسار: التعلّم -> التدريب -> المهام -> النتيجة",
  "changeSetup": "تغيير الإعداد",
  "changeDomain": "اختر منطقة أخرى",
  "backToLevelScreen": "العودة إلى شاشة المستوى",
  "domainLabel": "منطقة التعلم",
  "scenarioLabel": "السيناريو",
  "learnLabel": "التعلّم",
  "practiceLabel": "التدريب",
  "vocabularyLabel": "المفردات",
  "dialogueLabel": "المهام",
  "resultLabel": "النتيجة",
  "previous": "السابق",
  "next": "تابع",
  "learnTitle": "1) أولاً، راجع الاستخدام الصحيح",
  "learnHint": "استمع إلى الحوار النموذجي وتعرّف إلى مواضع استخدام كل عبارة.",
  "learnRoleSwitchYes": "يتضمن هذا السيناريو أدوار السؤال والإجابة.",
  "learnRoleSwitchNo": "يركز هذا السيناريو على دور واحد؛ يتم تدريب الدور الآخر في سيناريو آخر.",
  "contextLabel": "السياق",
  "listen": "استمع",
  "practiceTitle": "2) أنت الآن تتكلم",
  "practiceHint": "كرر هذه العبارات بصوت عالٍ لبناء الطلاقة الطبيعية.",
  "practiceActionLead": "اضغط على الميكروفون وقل الجملة بصوت عالٍ.",
  "practiceActionStepRead": "1) اقرأ الجملة",
  "practiceActionStepSpeak": "2) اضغط على الميكروفون أدناه للاختبار",
  "practiceActionDone": "تم",
  "dialogueTitle": "3) مهام من مواقف الحياة اليومية",
  "dialogueHint": "راجع موقف المهمة، ثم قل الجملة المتوقعة بصوت عالٍ.",
  "dialogueYourTurn": "دورك",
  "resultTitle": "4) ملخص الدرس",
  "resultHint": "لقد رأيت وتدربت على العبارات الأساسية لهذا السيناريو.",
  "resultRestartLesson": "إعادة تشغيل الدرس",
  "audioPlaying": "يتم تشغيل الصوت",
  "audioError": "لا يمكن تشغيل الصوت الآن. يرجى المحاولة مرة أخرى.",
  "packMissingTitle": "الحزمة المطلوبة ليست جاهزة",
  "packMissingHint": "يجب عليك إنهاء التنزيل قبل الدخول إلى منطقة التعلم هذه.",
  "goDownload": "العودة إلى خطوة التنزيل",
  "genericError": "تعذر تحميل المحتوى الآن.",
  "startupFailureTitle": "تعذر فتح التطبيق",
  "startupFailureBody": "حاول مرة أخرى أو أعد ضبط موضع التنقل المحفوظ فقط.",
  "startupRetry": "حاول مرة أخرى",
  "startupRepairNavigation": "إعادة ضبط التنقل",
  "startupRepairHint": "سيتم الاحتفاظ بتقدمك والمحتوى المحمّل وبيانات حسابك.",
  "startupDiagnosticLabel": "رمز التشخيص",
  "pickDomainTitle": "اختر منطقة التعلم",
  "pickDomainHint": "ابدأ بمجال واحد لتتقدم بخطوات واضحة.",
  "pickScenarioTitle": "اختر السيناريو الخاص بك",
  "pickScenarioHint": "اختر سيناريو واحدًا وتقدّم بالترتيب.",
  "pickModeTitle": "اختر وضع التعلم",
  "pickModeHint": "الترتيب المقترح: تدريب الجمل أولًا، ثم المفردات، ثم المهام في النهاية.",
  "pickVocabularyTitle": "اختر ممارسة المفردات",
  "pickVocabularyHint": "اختر بطاقة لفتح مسار استوديو الكلمات أو تمارين المفردات.",
  "pickVocabularyExercisesTitle": "اختر تمارين المفردات",
  "pickVocabularyExercisesHint": "اختر التمرين الذي تريد أن تبدأ به في هذا السيناريو.",
  "startScenarioLesson": "ابدأ هذا السيناريو",
  "changeScenario": "اختر سيناريو آخر",
  "translationMissing": "نص المساعدة غير جاهز لهذا السطر بعد.",
  "dialogLabel": "الحوار",
  "listenDialogue": "استمع إلى الحوار الكامل",
  "learnNextDialogue": "الحوار التالي",
  "learnOpenDetails": "إظهار تفاصيل اللغة",
  "learnBackToDialogues": "العودة إلى مربعات الحوار",
  "practiceTryVoice": "تحدّث واختبر",
  "practiceStopVoice": "إيقاف التسجيل",
  "practiceListening": "جارٍ الاستماع... قل الجملة الآن.",
  "practiceProcessing": "جاري التقييم...",
  "practiceTranscript": "ما سمعناه",
  "practiceClarity": "الوضوح",
  "practiceTaskFit": "مطابقة الجملة",
  "practiceTaskFitMatch": "مطابق",
  "practiceTaskFitMismatch": "غير متطابق",
  "practiceTaskFitUnknown": "غير واضح",
  "practiceBandPass": "واضح",
  "practiceBandLow": "واضح جزئيًا",
  "practiceBandFail": "يحتاج إلى عمل",
  "practiceVoiceUnavailable": "لا يمكن أن يبدأ الكلام الآن. يرجى المحاولة مرة أخرى.",
  "practiceSpeechPermissionDenied": "مطلوب إذن الميكروفون لبدء اختبار الكلام.",
  "practiceSpeechNoMatch": "لم يتم اكتشاف أي كلام. تحدث بشكل أقرب وأعد المحاولة.",
  "practiceSpeechModelPreparing": "جاري إعداد نموذج الخطاب التركي. انتظر لحظة وحاول مرة أخرى.",
  "practiceSpeechBusy": "التعرّف على الكلام مشغول. انتظر قليلًا ثم حاول مرة أخرى.",
  "practiceNextSentence": "الجملة التالية",
  "assistedProgressAction": "انتقل إلى التالي",
  "assistedProgressHint": "لن تُحتسب هذه الخطوة كمكتملة ولن تمنحك مكافأة.",
  "practiceChapterLabel": "الفصل",
  "practiceIntroFallbackHint": "في هذا الفصل ستتدرّب على الأنماط بالترتيب.",
  "practiceLockedShortAdLabel": "يُفتح بإعلان",
  "practiceLockedLabel": "مغلق",
  "practiceStartChapterAction": "ابدأ التدريب",
  "practiceChapterCompleteTitle": "اكتمل الفصل",
  "practiceChapterCompleteFinalHint": "لقد أنهيت جميع فصول التدريب. يمكنك الآن الانتقال إلى مهام الحوار.",
  "practiceChapterCompleteNextHint": "تقدم جميل. تابع إلى الفصل التالي عندما تكون مستعدًا.",
  "practiceReplayChapterAction": "إعادة الفصل",
  "practiceGoToMissionsAction": "اذهب إلى المهام",
  "practiceNextChapterAction": "الفصل التالي",
  "practiceCollectedLabel": "المحصّل",
  "practiceTargetSentenceLabel": "الجملة المستهدفة",
  "practiceNoIntentContentState": "لا يتوفر لهذا السيناريو محتوى تدريب قائم على الفصول بعد.",
  "practiceNoSentenceState": "لم يتم العثور على جملة تدريبية لهذا السيناريو.",
  "vocabularyAudioLabel": "صوت المفردات",
  "missionAudioLabel": "صوت المهمة",
  "sectionAudioLabel": "صوت هذا القسم",
  "sentenceAudioLabel": "صوت الجملة",
  "audioUnlockPromptTitle": "افتح هذه الحزمة بإعلان",
  "audioUnlockPromptMessageTemplate": "يتيح إعلان واحد {unitLabel} مجانًا وينزلها إلى هذا الجهاز. لن تحتاج إلى إعلان آخر للحزمة نفسها ما دامت جاهزة على هذا الجهاز.",
  "audioUnlockPromptCancelLabel": "ليس الآن",
  "audioUnlockPromptConfirmLabel": "شاهد الإعلان وافتح",
  "audioOpenUnavailableTitle": "لا يمكن فتحه الآن",
  "audioSectionRelockedTitle": "تم قفل القسم مرة أخرى",
  "audioSectionRelockedMessage": "تم قفل هذا القسم مرة أخرى لأن الصوت المطلوب لم يعد موجودًا على هذا الجهاز.",
  "simulationSupportHint": "عندما يحين دورك، قل السطر واختبره فورًا إذا لزم الأمر.",
  "simulationLearnerAction": "قل هذا السطر بصوت عالٍ",
  "simulationShowHint": "اعرض التلميح",
  "simulationShowAnswer": "اعرض الإجابة النموذجية",
  "simulationHintTitle": "تلميح",
  "simulationAnswerTitle": "الإجابة النموذجية",
  "simulationTaskTitle": "المهمة",
  "simulationCompletionRequired": "أكمل جميع مهام المهمة قبل المتابعة.",
  "simulationListenFlow": "استمع للتدفق",
  "simulationMissionLabel": "المهمة",
  "simulationSceneLabel": "المشهد",
  "simulationGoalLabel": "الهدف",
  "simulationExpectedSentenceLabel": "الجملة المتوقعة",
  "simulationStartTitle": "المهمة",
  "simulationStartPromptRespond": "استمع ثم قل الجملة المناسبة.",
  "simulationStartPromptInitiate": "ابدأ المحادثة ثم قل الجملة المناسبة.",
  "simulationChoiceHint": "قل الجملة الصحيحة: الخيار أ أو ب.",
  "simulationStartButton": "أنا جاهز",
  "simulationPreviewReadyButton": "اعرض الحوار",
  "simulationNextTask": "المهمة التالية",
  "simulationFinishFlow": "إنهاء المهام",
  "simulationWaitLabel": "انتظر",
  "simulationYourTurnLabel": "دورك",
  "simulationReadyNextLabel": "جاهز: انتقل إلى المهمة التالية",
  "simulationStartRequired": "ابدأ المهمة أولاً.",
  "simulationPreviewListenRequired": "استمع إلى كل سطر أولاً",
  "simulationPreviewReadyLabel": "جاهز: ابدأ المهمة",
  "simulationPreviewProgressLabel": "الأسطر التي تمت مراجعتها",
  "simulationAutoCountdownLabel": "سيفتح الميكروفون خلال",
  "simulationPreviewSceneGoalBadge": "المهمة",
  "simulationPreviewDialogueBadge": "راجع الحوار",
  "simulationRetryButton": "أعد المحاولة",
  "simulationRetryWrongOption": "لقد سمعتك، ولكن هذا ليس الخيار الصحيح لهذه المهمة. يرجى المحاولة مرة أخرى.",
  "simulationRetryExactMatch": "حاول أن تقول الجملة الظاهرة على الشاشة كما هي.",
  "simulationRetryNotClear": "لم أستطع أن أفهم بوضوح. يرجى المحاولة مرة أخرى.",
  "simulationPrefixScopeNote": "هذه المحاولة تحققت فقط من بداية الجملة.",
  "simulationCompleteTitle": "اكتملت المحاكاة",
  "simulationCompleteHint": "لقد أحرزت تقدمًا في الإجابات المناسبة خلال هذا التدفق.",
  "simulationNoStepState": "لم يتم العثور على خطوة محاكاة للمتعلم في هذا السيناريو.",
  "flowLabel": "المهمة",
  "languageTurkish": "تركي",
  "languageEnglish": "الإنجليزية",
  "speakerLearner": "أنت",
  "speakerGuide": "دبليو إيكو",
  "domainSocialInteraction": "التفاعل الاجتماعي",
  "domainDailyLife": "الحياة اليومية",
  "domainServicesPublic": "الخدمات / المواقف العامة",
  "domainCommunicationRepair": "إصلاح الاتصالات",
  "microSkillLabel": "المهارة الدقيقة",
  "contextsLabel": "السياقات",
  "progressLabel": "التقدم",
  "sequentialRecommendationTitle": "يوصى بالمسار المتسلسل",
  "sequentialRecommendationMessageTemplate": "يوصى بإكمال السيناريو {scenarioNumber} أولاً.",
  "openRecommendedLabel": "يوصى بالفتح",
  "openAnywayLabel": "افتحه على أي حال",
  "showAllChoices": "عرض كل الخيارات",
  "missionStatsAccuracy": "الدقة",
  "missionStatsFluency": "الطلاقة",
  "missionStatsStars": "نجوم",
  "missionStatsXp": "XP",
  "diamondsLabel": "عملة دبليو",
  "xpLabel": "XP",
  "missionStatsStreak": "خط",
  "statusCompleted": "مكتمل",
  "statusInProgress": "قيد التقدم",
  "statusNew": "جديد",
  "scenarioTapHint": "اضغط للبدء",
  "modeTapHint": "اضغط للفتح",
  "openNowTag": "مفتوح الآن",
  "signInRewardedTag": "تسجيل الدخول + إعلان",
  "guestStarterHint": "القسم الأول مفتوح الآن. تُفتح حزم الصوت الأخرى بعد تسجيل الدخول بإعلان عند الحاجة.",
  "vocabularyUnlockHint": "يُفتح صوت المفردات بشكل منفصل. تتطلب البطاقات المقفلة تسجيل الدخول أولاً، ثم إعلانًا.",
  "modeCardLearnContent": "أمثلة على الحوارات",
  "modeCardPracticeContent": "تدريب الجمل",
  "modeCardVocabularyContent": "ممارسة المفردات",
  "modeCardMissionsContent": "المهام",
  "modeStatsDialogues": "الحوارات",
  "modeStatsPrompts": "العبارات",
  "modeStatsWords": "الكلمات",
  "modeStatsMissions": "المهام",
  "modeStatsReviewed": "تمت المراجعة",
  "modeStatsCompleted": "مكتمل",
  "mixedMissionsTitle": "مهام مختلطة",
  "mixedMissionsHint": "افتح مساحة مراجعة من أصوات المهام الجاهزة على هذا الجهاز.",
  "mixedMissionsLoadingTitle": "جارٍ تجهيز المهام",
  "mixedMissionsLoadingHint": "يتم التحقق من المهام التي تم تنزيلها على هذا الجهاز. ستظهر هنا بعد قليل.",
  "mixedMissionsEmptyTitle": "المساحة فارغة الآن",
  "mixedMissionsEmptyHint": "بعد تنزيل أصوات مهام أحد السيناريوهات، تظهر تلك المهام هنا.",
  "mixedMissionsReadyTag": "جاهز للمراجعة",
  "mixedMissionsUnavailableTag": "غير جاهز بعد",
  "mixedMissionsOpenAction": "افتح المهمة",
  "mixedMissionsStartMixedAction": "ابدأ مهمة مختلطة",
  "mixedMissionsPickMissionAction": "اختر مهمة",
  "mixedMissionsPickerTitle": "اختر مهمة",
  "mixedMissionsPickerCloseAction": "أغلق اختيار المهمة",
  "mixedMissionsAllLevelsFilter": "الكل",
  "mixedMissionsLevelFilterLabel": "تصفية المستوى",
  "vocabularyStudioTitle": "استوديو الكلمات",
  "vocabularyStudioHint": "استمع إلى كل كلمة، وقلها بصوت عالٍ، ثم كررها.",
  "vocabularyExercisesTitle": "تمارين المفردات",
  "vocabularyExercisesHint": "اختر تمرين الاستماع أو الكتابة أو ترتيب الحروف الذي تريد أن تبدأ به.",
  "vocabularyExerciseListenRepeatTitle": "استمع وكرر",
  "vocabularyExerciseListenRepeatHint": "استمع إلى الكلمة، وقلها بصوت عالٍ، ثم كررها.",
  "vocabularyExerciseUnscrambleTitle": "حل الرموز",
  "vocabularyExerciseUnscrambleHint": "إعادة بناء الكلمة الصحيحة من الحروف المختلطة.",
  "vocabularyExerciseListenWriteTitle": "استمع واكتب",
  "vocabularyExerciseListenWriteHint": "اكتب الكلمة التي تسمعها بشكل صحيح.",
  "vocabularyPreviewTitle": "معاينة",
  "vocabularyAudioReadyLabel": "الصوت جاهز",
  "vocabularyAudioPendingLabel": "الصوت معلق",
  "vocabularyContextUnit": "السياقات",
  "vocabularyEmptyState": "بيانات المفردات ليست جاهزة لهذا السيناريو بعد.",
  "vocabularyStartAction": "ابدأ",
  "vocabularyRestartAction": "إعادة التشغيل",
  "vocabularyCheckAction": "تحقق",
  "vocabularyNextWordAction": "الكلمة التالية",
  "vocabularyExamplesAction": "أمثلة",
  "vocabularyHideExamplesAction": "إخفاء الأمثلة",
  "vocabularyWordLabel": "كلمة",
  "vocabularyExamplesLabel": "الجمل سبيل المثال",
  "vocabularyNoExamplesState": "لا توجد جمل مثال مرتبطة بهذه الكلمة بعد.",
  "vocabularyListenAction": "استمع",
  "vocabularyStopAction": "توقف",
  "vocabularyRecognizedLabel": "الكلمة التي التقطناها",
  "vocabularyWritePlaceholder": "اكتب الكلمة التي تسمعها",
  "vocabularyYourAnswerLabel": "إجابتك",
  "vocabularyCorrectAnswerLabel": "الكلمة الصحيحة",
  "vocabularyScoreLabel": "XP",
  "vocabularyHintOneAction": "تلميح 1",
  "vocabularyHintTwoAction": "التلميح 2",
  "vocabularyGiveUpAction": "استسلم",
  "vocabularyClearAction": "واضح",
  "vocabularyBackspaceAction": "مسافة للخلف",
  "vocabularySpellingHintAction": "تلميح الحروف",
  "vocabularyMeaningHintLabel": "مساعدة لغوية",
  "vocabularyAudioHintLabel": "تلميح صوتي",
  "vocabularyAudioHintPlayed": "تم تشغيل الكلمة الصوتية. يمكنك الاستماع مرة أخرى.",
  "vocabularyFeedbackCorrect": "صحيح",
  "vocabularyFeedbackIncorrect": "ليست صحيحة بعد",
  "vocabularyFeedbackGiveUp": "كشفت الكلمة",
  "vocabularyFeedbackHintLabel": "تلميح للتدريب",
  "vocabularyFeedbackListenRepeatHint": "استمع مرة أخرى. قل الكلمة على أجزاء صغيرة وابق قريبًا من الميكروفون.",
  "vocabularyFeedbackListenWriteHint": "استمع مرة أخرى. راجع الكتابة وصحّح إجابتك.",
  "vocabularyFeedbackUnscrambleHint": "لا تستسلم الآن. استخدم التلميحات لتقريب ترتيب الحروف.",
  "vocabularyFeedbackCloseAction": "إغلاق النتيجة",
  "clarityRailLabel": "الوضوح",
  "rewardCollectedLabel": "تم جمع المكافأة",
  "diamondCollectedLabel": "تم جمع المكافأة",
  "statusListeningLabel": "الاستماع",
  "statusProcessingLabel": "المعالجة",
  "statusEvaluatingLabel": "التقييم",
  "retryShortLabel": "حاول مرة أخرى",
  "genericStatusLabel": "الحالة",
  "genericFeedbackLabel": "ردود الفعل",
  "practiceRailListeningHint": "يمتلئ المؤشر مع تقدّم نطقك.",
  "practiceRailProcessingHint": "جارٍ احتساب الوضوح النهائي.",
  "practiceRailPassRewardHint": "نطق واضح. تم جمع المكافأة.",
  "practiceRailPassXpHint": "نطق واضح. تمت إضافة XP جديدة.",
  "practiceRailPassReviewHint": "نطق واضح. تمت المراجعة.",
  "practiceRailRetryHint": "اضغط على الميكروفون وحاول تنفيذ نفس الجملة مرة أخرى.",
  "missionRailListeningHint": "سيتحرّك مؤشر الوضوح مع وصول صوتك.",
  "missionRailProcessingHint": "جاري معالجة الوضوح النهائي.",
  "missionRailPassRewardHint": "الوضوح الكامل. تم جمع المكافأة.",
  "missionRailPassContinueHint": "اكتملت المهمة. استمر عندما تكون جاهزًا.",
  "missionRailIdleHint": "سيتحرّك مؤشر الوضوح مع وصول صوتك.",
  "simulationLiveFeedbackListening": "قل سطرك. ستظهر الملاحظات هنا.",
  "simulationLiveFeedbackProcessing": "جارٍ إعداد نتيجتك.",
  "fullScreenPreviousMissionLabel": "المهمة السابقة",
  "fullScreenNextMissionLabel": "المهمة القادمة",
  "fullScreenPreviousSentenceLabel": "الجملة السابقة",
  "fullScreenNextSentenceLabel": "الجملة التالية",
  "vocabularyTryAgainHint": "اضبط إجابتك وتأكد مرة أخرى.",
  "translateAction": "ترجمة",
  "hideTranslation": "إخفاء الترجمة",
  "translationLoading": "ترجمة...",
  "translationError": "الترجمة غير متاحة حاليًا.",
  "noScenarioSelectedError": "لم يتم اختيار أي سيناريو بعد.",
  "firstUseGuideTitle": "بداية سريعة",
  "firstUseGuideStepLabel": "الخطوة",
  "firstUseGuideSkip": "تخطّي",
  "firstUseGuideNext": "التالي",
  "firstUseGuideDone": "تم",
  "firstUseGuideSteps": [
    {
      "title": "اختر اللغة التي تتحدثها",
      "body": "اختر اللغة التي تريد أن تظهر بها الإرشادات والتلميحات."
    },
    {
      "title": "اختر لغة التعلّم",
      "body": "اختر اللغة التي تريد التدرّب على التحدث بها."
    },
    {
      "title": "اختر المستوى والسيناريو",
      "body": "ابدأ بالمستوى المناسب. بعده افتح مجالًا تعليميًا واختر بطاقة سيناريو."
    },
    {
      "title": "استخدم الوصول السريع",
      "body": "ارجع إلى الشاشات الأساسية من القائمة الجانبية. إذا غطّت الأيقونة جزءًا مهمًا، اسحبها إلى الجانب الآخر."
    }
  ],
  "controlledTrialProgressLabel": "جولة تجريبية",
  "controlledTrialStart": "ابدأ",
  "controlledTrialStarting": "جارٍ التحضير",
  "controlledTrialPreparing": "جارٍ تجهيز الجولة التجريبية",
  "controlledTrialLockedTag": "أكمل الجولة أولًا",
  "controlledTrialBlockedTitle": "أكمل الجولة التجريبية أولًا",
  "controlledTrialBlockedBody": "ستُفتح الخيارات الأخرى بعد إكمال هذه الخطوة القصيرة.",
  "controlledTrialBlockedAction": "تابع الجولة",
  "controlledTrialCompletionTitle": "تهانينا!",
  "controlledTrialCompletionBody": "أصبحت الآن تعرف كيفية استخدام التطبيق.",
  "controlledTrialCompletionItems": [
    "تدريب الجمل",
    "تدريب المفردات",
    "المهام",
    "مجموعة المهام"
  ],
  "controlledTrialCompletionAction": "اختر مستواك",
  "controlledTrialStages": [
    {
      "title": "لنجرّب أولًا تدريب الجمل",
      "body": "استمع إلى الجملة، واضغط على الميكروفون، ثم قلها بصوت عالٍ."
    },
    {
      "title": "والآن لنتدرّب على الكلمات",
      "body": "استمع إلى الكلمة وكرّرها بصوت عالٍ."
    },
    {
      "title": "والآن لنجرب مهمة حقيقية",
      "body": "اطّلع على الموقف، واستمع إلى الحوار، ثم قدّم ردك بصوتك."
    },
    {
      "title": "وأخيرًا، اكتشف مجموعة مهامك",
      "body": "اضغط على اختيار مهمة، وحدد مهمة نزّلتها، ثم اضغط على فتح المهمة."
    }
  ],
  "controlledTrialVocabularyStages": [
    {
      "title": "استمع إلى الكلمة وكرّرها أولًا",
      "body": "استمع إلى الكلمة، واضغط على الميكروفون، ثم كرّرها بصوت عالٍ."
    },
    {
      "title": "رتّب الحروف الآن",
      "body": "اختر الحروف المختلطة لإعادة تكوين الكلمة نفسها."
    },
    {
      "title": "اكتب الكلمة أخيرًا",
      "body": "استمع إلى الكلمة ثم اكتبها بالشكل الصحيح."
    }
  ],
  "contextGuideDomainTitle": "من أين تبدأ؟",
  "contextGuideDomainSteps": [
    {
      "title": "ابدأ حسب الأرقام",
      "body": "توضح الأرقام ترتيب الدراسة المقترح. افتح أول بطاقة غير مكتملة تحمل أصغر رقم."
    },
    {
      "title": "اختر موضوعًا آخر عند الحاجة",
      "body": "إذا كان موضوع آخر أنسب لجلسة اليوم، افتح بطاقته مباشرة. الرقم للتوجيه، لا للإجبار."
    },
    {
      "title": "حافظ على نفس الإيقاع",
      "body": "بعد فتح المجال، ابدأ بأول سيناريو غير مكتمل. هكذا يصبح التقدّم أسهل في المتابعة."
    }
  ],
  "contextGuideModeTitle": "الترتيب المقترح لهذا السيناريو",
  "contextGuideModeSteps": [
    {
      "title": "ابدأ بتدريب الجمل",
      "body": "استمع إلى الجمل أولًا، ثم قلها بصوت واضح. يساعدك ذلك على فهم الجمل وتحسين النطق."
    },
    {
      "title": "ثبّت الكلمات",
      "body": "راجع كلمات السيناريو المهمة داخل سياقها."
    },
    {
      "title": "اختم بالمهام",
      "body": "استخدم الجمل والكلمات داخل حوار عملي. افتح بطاقة أخرى إذا أردت ترتيبًا مختلفًا."
    }
  ],
  "contextGuidePracticeTitle": "قبل تدريب الجمل",
  "contextGuidePracticeSteps": [
    {
      "title": "اختر قسمًا",
      "body": "تضم هذه الشاشة أقسام جمل السيناريو. ابدأ بالقسم المفتوح، وافتح الأقسام الأخرى مع تقدّمك."
    },
    {
      "title": "استمع ثم تكلّم",
      "body": "استمع إلى الجملة. بعد ذلك المس الميكروفون وقلها بوضوح."
    },
    {
      "title": "راجع النتيجة",
      "body": "عند وصول الوضوح إلى المستوى المطلوب، يُحفظ تقدّمك. أعد أي جملة تبدو صعبة."
    }
  ],
  "contextGuideVocabularyTitle": "قبل تدريب المفردات",
  "contextGuideVocabularySteps": [
    {
      "title": "الكلمات من السيناريو",
      "body": "كل كلمة هنا مأخوذة من جمل السيناريو. استمع إلى السياق أولًا، ثم ركّز على الكلمة."
    },
    {
      "title": "ابدأ بالاستماع والتكرار",
      "body": "ابدأ بجولة الاستماع والتكرار. بعدها ثبّت الكلمة بتمارين الكتابة والترتيب."
    },
    {
      "title": "اتخذ الترتيب كدليل",
      "body": "افتح تمرينًا آخر مباشرة إذا كان أنسب لجلسة اليوم. هذا هو الترتيب المقترح فقط."
    }
  ],
  "contextGuideMissionsTitle": "قبل المهام",
  "contextGuideMissionsSteps": [
    {
      "title": "اقرأ الموقف والهدف",
      "body": "اقرأ الموقف والهدف بلغة التعلّم أولًا. استخدم العلم عند الحاجة إلى مساعدة بلغتك."
    },
    {
      "title": "استعد بالحوار",
      "body": "استمع إلى الحوار النموذجي بالترتيب. عندما تكون جاهزًا، أنجز الهدف نفسه بصوتك."
    },
    {
      "title": "أكمل التبادل",
      "body": "اجعل المهمة تدريبًا قريبًا من الحديث الحقيقي. إذا تعثّرت، أعد المحاولة بالسرعة التي تناسبك."
    }
  ],
  "contextGuideMixedMissionsTitle": "قبل المهام المختلطة",
  "contextGuideMixedMissionsSteps": [
    {
      "title": "المساحة من مهام الجهاز",
      "body": "عند تنزيل أصوات مهام سيناريو ما، تُضاف تلك المهام إلى هذه المساحة. لا يتم تنزيل محتوى جديد هنا."
    },
    {
      "title": "اختر تصفية المستوى",
      "body": "اختر مستوى واحدًا، أو افتح الكل لمهمة من كل مستوى جاهز على هذا الجهاز."
    },
    {
      "title": "راجع في تمرين منفصل",
      "body": "كل بطاقة تفتح المهمة المحددة كتمرين منفصل من دون الدخول إلى مسار الدرس العادي. أنهِها، ثم عُد إلى هنا واختر مهمة مراجعة أخرى."
    }
  ],
  "quickAccessOpenLabel": "افتح القائمة السريعة",
  "quickAccessCloseLabel": "أغلق القائمة السريعة",
  "quickAccessTitle": "وصول سريع",
  "quickAccessHint": "انتقل مباشرة إلى الشاشات الشائعة.",
  "quickAccessLanguageSettingsLabel": "إعدادات اللغة",
  "quickAccessCurrentScenario": "السيناريو الحالي",
  "quickAccessMixedMissions": "مهام مختلطة",
  "quickAccessUnavailableHint": "أكمل اختيار اللغة والمستوى أولًا."
};

export const AR_SETUP_LEVEL_SUBTITLES: SetupLevelSubtitleCopy = {
  "a1": "مبتدئ",
  "a2": "مبتدئ أعلى",
  "b1": "متوسط",
  "b2": "متوسط متقدم"
};

export const AR_BACKEND_SMOKE_COPY: BackendSmokeCopy = {
  "title": "فحص النظام",
  "run": "شغّل الفحص",
  "idle": "جاهز",
  "running": "قيد التشغيل...",
  "success": "اكتمل الفحص",
  "error": "تعذّر إكمال الفحص",
  "hint": "يمر هذا الفحص الداخلي عبر تسجيل الدخول وإعداد الصوت.",
  "uid": "حساب",
  "attemptId": "محاولة",
  "endpoint": "اتصال",
  "authPresent": "تسجيل الدخول جاهز",
  "providerIds": "تسجيلات الدخول",
  "downloadAuthorized": "التنزيل جاهز",
  "authorizationSource": "نوع الوصول",
  "scenario": "السيناريو",
  "errorCode": "خطأ",
  "phase": "المرحلة"
};

export const AR_REMOTE_AUDIO_INSTALL_SMOKE_COPY: RemoteAudioInstallSmokeCopy = {
  "title": "فحص إعداد الصوت",
  "run": "شغّل الفحص",
  "idle": "جاهز",
  "running": "قيد التشغيل...",
  "success": "اكتمل الفحص",
  "error": "تعذّر إكمال الفحص",
  "hint": "يقوم هذا الفحص الداخلي بتنزيل الصوت المطلوب والتأكد من أنه جاهز على الجهاز.",
  "uid": "حساب",
  "providerIds": "تسجيلات الدخول",
  "authorizationSource": "نوع الوصول",
  "fileStoreVerified": "الصوت جاهز",
  "audioRefCount": "عدد الصوت",
  "newlyInstalledAudioRefCount": "صوت جديد",
  "alreadyInstalledAudioRefCount": "صوت جاهز",
  "playableSourceKind": "المصدر",
  "playableUri": "رابط التشغيل",
  "storageUnitKey": "الحزمة",
  "scenario": "السيناريو",
  "errorCode": "خطأ",
  "phase": "المرحلة"
};

export const AR_REWARDED_AD_UNLOCK_SMOKE_COPY: RewardedAdUnlockSmokeCopy = {
  "title": "فحص الفتح بإعلان بمكافأة",
  "run": "شغّل الفحص",
  "idle": "جاهز",
  "running": "قيد التشغيل...",
  "success": "اكتمل الفحص",
  "error": "تعذّر إكمال الفحص",
  "hint": "يؤكد هذا الفحص الداخلي أن الإعلان بمكافأة يمكنه فتح القسم وتجهيز الصوت الخاص به.",
  "uid": "حساب",
  "providerIds": "تسجيلات الدخول",
  "kind": "نوع",
  "grantedReceiptActive": "الوصول مفتوح",
  "rewardStatus": "نتيجة الفيديو",
  "adUnitId": "فتحة الفيديو",
  "audioRefCount": "عدد الصوت",
  "newlyInstalledAudioRefCount": "صوت جديد",
  "alreadyInstalledAudioRefCount": "صوت جاهز",
  "fileStoreVerified": "الصوت جاهز",
  "playableSourceKind": "المصدر",
  "playableUri": "رابط التشغيل",
  "storageUnitKey": "الحزمة",
  "scenario": "السيناريو",
  "errorCode": "خطأ",
  "phase": "المرحلة"
};

export const AR_REWARDED_UNLOCK_PROMPT_COPY: RewardedUnlockPromptCopy = {
  "title": "افتح هذه الحزمة بإعلان",
  "message": "يتيح إعلان واحد هذه الحزمة الصوتية مجانًا. لن تحتاج إلى إعلان آخر ما دامت الحزمة جاهزة على هذا الجهاز.",
  "cancelLabel": "ليس الآن",
  "confirmLabel": "شاهد الإعلان وافتح"
};

export const AR_PROVIDER_INTERACTIVE_PROMPT_COPY: ProviderInteractivePromptCopy = {
  "title": "سجّل الدخول لفتح مزيد من الصوت",
  "messageTemplate": "تظل الأنشطة الأولى مفتوحة بدون تسجيل الدخول. تابع مع {provider} لفتح المزيد من الصوت وحفظ تقدمك في هذا الحساب.",
  "confirmLabel": "تابع",
  "cancelLabel": "ليس الآن"
};

export const AR_MICROPHONE_PERMISSION_COPY: MicrophonePermissionCopy = {
  "title": "الوصول إلى الميكروفون",
  "message": "مطلوب الوصول إلى الميكروفون لممارسة التحدث.",
  "buttonPositive": "السماح",
  "buttonNegative": "إلغاء"
};

export const AR_ACCOUNT_UI_COPY: AccountUiCopy = {
  "domainButton": "الملف الشخصي",
  "title": "الملف الشخصي والحساب",
  "hint": "يمكنك الاستمرار كضيف. بمجرد تسجيل الدخول، يظل المحتوى غير المؤمن والتقدم الخاص بك مرتبطًا بهذا الحساب.",
  "noteAndroid": "يمكنك تسجيل الدخول باستخدام Google على هذا الجهاز.",
  "noteIos": "يمكنك تسجيل الدخول باستخدام Apple على هذا الجهاز.",
  "back": "العودة",
  "status": "الحالة",
  "notSignedIn": "أنت تتصفح كضيف",
  "signedIn": "الحساب متصل",
  "checking": "إعداد حسابك",
  "signingIn": "تسجيل دخولك",
  "signingOut": "تسجيل الخروج",
  "deletingAccount": "جارٍ حذف الحساب",
  "authError": "لا يمكن إكمال تسجيل الدخول",
  "phase": "الآن",
  "approvedProvider": "طريقة تسجيل الدخول",
  "level": "المستوى",
  "spokenLanguage": "اللغة التي أتحدثها",
  "changeSpokenLanguage": "تغيير اللغة التي أتحدثها",
  "targetLanguage": "اللغة المستهدفة",
  "signedInBody": "يظل المحتوى غير المؤمَّن والتقدم الذي أحرزته مرتبطًا بهذا الحساب.",
  "signedOutBody": "تظل الأقسام الأولى مفتوحة. يحتاج الصوت المقفل إلى تسجيل الدخول.",
  "guestAccessTitle": "مفتوح الآن",
  "guestAccessBody": "الأقسام الأولى، وتصفح السيناريو، والتدفق التجريبي الأساسي.",
  "protectedFeaturesTitle": "يفتح بعد تسجيل الدخول",
  "protectedFeaturesBody": "يمكن فتح الصوت والمهام المقفلة بإعلان بعد تسجيل الدخول. لن تطلب الحزمة نفسها إعلانًا آخر ما دامت جاهزة على هذا الجهاز.",
  "premiumTitle": "بريميوم",
  "premiumBody": "بريميوم اشتراك شهري يتجدد تلقائيًا. أثناء تفعيله، يزيل الإعلانات ويفتح الصوت المقفل مباشرة.",
  "premiumActionLabel": "اشترك في بريميوم",
  "premiumRestoreLabel": "استعادة المشتريات",
  "premiumManageLabel": "إدارة الاشتراك",
  "premiumRestoreEmptyMessage": "لم يتم العثور على مشتريات متميزة نشطة لاستعادتها.",
  "premiumSubscriptionPeriodLabel": "المدة",
  "premiumSubscriptionPeriodValue": "شهر واحد، يتجدد تلقائيًا",
  "premiumSubscriptionPriceLabel": "السعر",
  "premiumSubscriptionPriceFallback": "يظهر في شاشة الشراء من المتجر قبل التأكيد",
  "premiumSubscriptionIncludedLabel": "يشمل",
  "premiumSubscriptionIncludedValue": "تُزال الإعلانات ويفتح الصوت المقفل مباشرة خلال كل فترة اشتراك نشطة.",
  "premiumSubscriptionRenewalNote": "يتجدد الاشتراك شهريًا حتى يتم إلغاؤه من إعدادات حساب App Store أو Google Play.",
  "premiumRestoreHint": "إذا كنت مشتركًا بالفعل، فاستعد المشتريات لاستعادة الوصول على هذا الجهاز.",
  "premiumLegalText": "بالاشتراك، أنت توافق على شروط الاستخدام وسياسة الخصوصية.",
  "premiumTermsLabel": "شروط الاستخدام",
  "premiumPrivacyLabel": "سياسة الخصوصية",
  "adPrivacyOptionsLabel": "خيارات خصوصية الإعلانات",
  "planLabel": "الخطة",
  "planFreeValue": "مجاني",
  "planPremiumValue": "بريميوم",
  "adsLabel": "الإعلانات",
  "adsOnValue": "تشغيل",
  "adsOffValue": "معطلة",
  "premiumStatusLabel": "الوصول",
  "premiumStatusInactiveValue": "غير نشط",
  "premiumStatusActiveValue": "نشط",
  "premiumStatusGraceValue": "الدفع معلق",
  "premiumCheckoutLabel": "حالة الشراء",
  "premiumCheckoutReadyValue": "جاهز",
  "premiumCheckoutPreparingValue": "التحضير",
  "premiumCheckoutUnavailableValue": "غير جاهز بعد",
  "remindersTitle": "التذكيرات",
  "remindersBody": "نذكّرك بالسيناريو أو تدريب الجمل أو المهام أو مراجعة المفردات التي توقفت عندها حسب التكرار الذي تختاره. الوقت الافتراضي هو 19:00.",
  "remindersStatusLabel": "التذكير",
  "remindersOnValue": "مفعّل",
  "remindersOffValue": "مغلق",
  "remindersPermissionDeniedValue": "الإذن مغلق",
  "remindersEnableLabel": "تشغيل التذكيرات",
  "remindersDisableLabel": "إيقاف التذكيرات",
  "remindersPreviewLabel": "نص الإشعار",
  "remindersFrequencyLabel": "التكرار",
  "remindersDailyValue": "يوميًا",
  "remindersWeeklyValue": "أسبوعيًا",
  "remindersChangeFrequencyLabel": "تغيير التكرار",
  "remindersTimeLabel": "الوقت",
  "remindersChangeTimeLabel": "تغيير الوقت",
  "remindersScheduledLabel": "التالي",
  "remindersNotScheduledValue": "غير مجدول",
  "remindersPermissionPromptTitle": "تذكيرات الدراسة",
  "remindersPermissionPromptMessage": "يمكننا إرسال تذكيرات لطيفة كي لا تنسى التدريب الذي توقفت عنده. اسمح بالإشعارات لتصلك حسب التكرار الذي تختاره.",
  "remindersPermissionPromptConfirm": "السماح بالإشعارات",
  "remindersPermissionPromptCancel": "ليس الآن",
  "appearanceTitle": "السمة",
  "settingsTitle": "الإعدادات",
  "appearanceBody": "اختر سمة Atelier أو الفاتحة أو الداكنة.",
  "appearanceModeLabel": "السمة",
  "appearanceDarkValue": "داكن",
  "appearanceLightValue": "فاتح",
  "appearanceFrequencyValue": "تردد",
  "monetizationCheckingValue": "التحقق",
  "uid": "الحساب",
  "providerIds": "تسجيلات الدخول المتصلة",
  "signInGoogle": "تابع مع جوجل",
  "signInApple": "تابع مع Apple",
  "refreshSession": "جلسة التحديث",
  "signOut": "تسجيل الخروج",
  "lazyPromptTitle": "سجّل الدخول لفتح مزيد من الصوت",
  "lazyPromptMessage": "يبقى أول محتوى مفتوحًا من دون تسجيل الدخول. تابع باستخدام {provider} لفتح هذه الحزمة بإعلان، أو استمر بدون إعلانات مع بريميوم.",
  "lazyPromptConfirm": "تابع",
  "lazyPromptCancel": "ليس الآن",
  "errorTitle": "حدث خطأ ما",
  "signOutConfirmTitle": "تسجيل الخروج؟",
  "signOutConfirmMessage": "سيؤدي هذا إلى إزالة اتصال الحساب على هذا الجهاز.",
  "signOutConfirmCancel": "إلغاء",
  "signOutConfirmApprove": "تسجيل الخروج",
  "deleteAccountTitle": "حذف الحساب",
  "deleteAccountBody": "عند حذف الحساب، تُزال بيانات التقدم وفتح المحتوى وربط الحساب. إذا كان لديك اشتراك نشط، ألغِه من المتجر أيضًا.",
  "deleteAccountAction": "حذف حسابي",
  "deleteAccountConfirmTitle": "هل تريد حذف الحساب؟",
  "deleteAccountConfirmMessage": "سيؤدي هذا إلى حذف الحساب وبيانات التقدم نهائيًا. إذا كان لديك اشتراك نشط، ألغِه بشكل منفصل من Google Play أو App Store.",
  "deleteAccountConfirmCancel": "إلغاء",
  "deleteAccountConfirmApprove": "نعم، احذف الحساب",
  "deleteAccountSuccessTitle": "تم حذف الحساب",
  "deleteAccountSuccessMessage": "تمت إزالة ربط الحساب وبيانات التقدم. يمكنك متابعة استخدام التطبيق كضيف.",
  "providerGoogleLabel": "جوجل",
  "providerAppleLabel": "أبل",
  "providerGenericLabel": "المزود"
};
